import { render, staticRenderFns } from "./ContactDetail.vue?vue&type=template&id=759734d2&scoped=true&"
import script from "./ContactDetail.vue?vue&type=script&lang=js&"
export * from "./ContactDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetail.vue?vue&type=style&index=0&id=759734d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759734d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('759734d2')) {
      api.createRecord('759734d2', component.options)
    } else {
      api.reload('759734d2', component.options)
    }
    module.hot.accept("./ContactDetail.vue?vue&type=template&id=759734d2&scoped=true&", function () {
      api.rerender('759734d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ccd/ContactDetail.vue"
export default component.exports